window.onload = function() {

    if (window.jQuery) {

        // show tab/collapsible by menù anchor from other page
        function getHash() {
            var hash = window.location.hash;
            if( hash && $( 'ul.nav-tabs a[href="' + hash + '"]' ).length > 0 ) {
                if( $( 'ul.nav-tabs' ).length > 0 )
                    hash && $( 'ul.nav-tabs a[href="' + hash + '"]' ).tab( 'show' );
                if( $( hash ).find( 'a[data-toggle="collapse"]' ).length > 0 )
                    $( hash ).find( '.collapse' ).collapse('show');
                setTimeout(
                    function() {
                        $( 'html,body' ).animate({scrollTop: $( hash ).offset().top},'500');
                    },
                300);
            }
        }

        // show tab/collapsible
        getHash();
        
        // Auto-generate carousel indicator html
        $( '.carousel:not(.quiz):not(.-product)' ).each(function() {
            var $carousel = $(this);
            var $id = $carousel.attr( 'id' );
            var $directions = ['prev','next'];
            var $slides = $carousel.find( '.carousel-inner' ).children( '.carousel-item' );
            $carousel.attr( 'data-ride', 'carousel' );
            if ($slides.length > 1) {
                if( $carousel.hasClass( '-indicators' ) ) {
                    $carousel.append( '<ol class="carousel-indicators"></ol>' );
                    var $indicator = $carousel.find( '.carousel-indicators' );
                    $slides.each(function( index ) {
                        if (index === 0) {
                            $(this).addClass( 'active' );
                            $indicator.append( '<li data-target="#' + $id + '" data-slide-to="' + index + '" class="active"></li>' );
                        } else
                            $indicator.append( '<li data-target="#' + $id + '" data-slide-to="' + index + '"></li>' );
                    });
                }
            }
            if( $carousel.hasClass( '-controls' ) ) {
                $slides.first().addClass( 'active' );
                if ($slides.length > 1) {
                    for ( var i = 0, l = $directions.length; i < l; i++ ) {
                        var $direction = $directions[ i ];
                        var $icon = '<span class="carousel-control-' + $direction + '-icon" aria-hidden="true"></span>';
                        var $sr =   '<span class="sr-only">' + $direction + '</span>';
                        var $control = $('<a/>')
                                        .attr({
                                            'href': '#' + $id,
                                            'role': 'button',
                                            'data-slide': $direction
                                        })
                                        .addClass( 'carousel-control-' + $direction );
                        $carousel
                            .append( $control.append( $icon + $sr ) );
                    }
                }
            }

            var img = new Image();

            /*
            var min_width = 50;
            $slides.each(function(){
                img.src = $(this).find('img').attr('src');
                if(img.width) {
                    min_width = img.width > min_width ? img.width : min_width;
                    console.log($id, img.width, min_width, $slides.length);
                }
            });

            if($carousel.hasClass('-sm'))            
                $carousel.css('max-width', $carousel.closest('div').width()).width(min_width);
            */
                
            $carousel.carousel({
                interval: 5000,
                pause: 'hover'
            });
        });

        window.$quiz = {
            0: {
                'question': 'Quanto latte serve per produrre una forma di Parmigiano Reggiano?',
                'answers':
                {
                    'A': '100 LITRI DI LATTE',
                    'B': '600 LITRI DI LATTE',
                    'C': '200 LITRI DI LATTE'
                },
                'image': 'forma-latte.png',
                'correct': 'B'
            },
            1: {
                'question': 'Qual è la stagionatura minima a cui la forma di Parmigiano Reggiano viene marchiata dal Consorzio del Parmigiano Reggiano?',
                'answers':
                {
                    'A': '12 MESI',
                    'B': '9 MESI',
                    'C': '36 MESI'
                },
                'image': 'forma.png',
                'correct': 'A'
            },
            2: {
                'question': 'Come si chiama l’attrezzo utilizzato dal casaro per rompere la cagliata?',
                'answers':
                {
                    'A': 'SPINO',
                    'B': 'SPACCA CAGLIATA',
                    'C': 'RASTRELLO'
                },
                'image': 'spino.png',
                'correct': 'A'
            }
        }
        window.$answers = {};
        window.$correctAnswers = 0;

        function createSlide( question, answers, image, results ) {
            var sliderLayout = `<div class="carousel-item">
                                    <div class="card border-0 px-4 py-6 w-lg-70 w-xl-85 mx-auto text-left">
                                        <p>` + question + `</p>
                                        <div class="row">
                                            <div class="col-sm">
                                                ` + answers + `
                                            </div>
                                            <div class="col-sm align-self-end">
                                                <img class="d-block mx-auto" src="/images/quiz/` + image + `" alt="Forma">
                                            </div>
                                        </div>
                                    </div>
                                </div>`;
            if (results)
                sliderLayout = `<div class="carousel-item">
                                    <div class="card border-0 px-4 py-6 w-lg-70 w-xl-85 mx-auto text-center">
                                        <h3>
                                        </h3>
                                        <div class="row">
                                        </div>
                                    </div>
                                </div>`;
            $('.quiz .carousel-inner')
                .append( sliderLayout );
        }

        // Auto-generate quiz carousel
        function launchQuiz () {
            
            var $carousel = $( '.carousel.quiz' );
            var $id = $carousel.attr( 'id' );
            var $directions = ['prev','next'];
            var $slides = $carousel.find( '.carousel-inner' ).children( '.carousel-item' );

            $slides.each(function( index ) {
                $(this).find('.btn-quiz').attr('data-slide', index);
            });

            if ($slides.length > 1) {
                if( $carousel.hasClass( '-indicators' ) ) {
                    $carousel.append( '<ol class="carousel-indicators"></ol>' );
                    var $indicator = $( '.carousel-indicators' );
                    $slides.each(function( index ) {
                        if (index === 0) {
                            $(this).addClass( 'active' );
                            $indicator.append( '<li class="active">'+(index+1)+'</li>' );
                        } else
                            if ((index+1) < $slides.length)
                                $indicator.append( '<li>'+(index+1)+'</li>' );
                    });
                }
            }
            if( $carousel.hasClass( '-controls' ) ) {
                $slides.first().addClass( 'active' );
                if ($slides.length > 1) {
                    for ( var i = 0, l = $directions.length; i < l; i++ ) {
                        var $direction = $directions[ i ];
                        var $icon = '<span class="carousel-control-' + $direction + '-icon" aria-hidden="true"></span>';
                        var $sr =   '<span class="sr-only">' + $direction + '</span>';
                        var $control = $('<a/>')
                                        .attr({
                                            'href': '#' + $id,
                                            'role': 'button',
                                            'data-slide': $direction
                                        })
                                        .addClass( 'carousel-control-' + $direction );
                        $carousel
                            .append( $control.append( $icon + $sr ) );
                    }
                }
            }
            $carousel.carousel({
                interval: false
            });
        }

        $( '.-start-quiz' ).on('click', function ( e ) {
            $('.-intro').fadeOut(300, function() {
                $.each(window.$quiz, function(i, qna) {
                    var buttons = '';
                    $.each(qna['answers'], function(key, value) {
                        buttons += '<button class="btn-quiz d-block"><span>' + key + '</span> ' + value + '</button>';
                    });
                    createSlide( qna['question'], buttons, qna['image'], false );
                    if(i == Object.keys($quiz).length -1 ) {
                        createSlide( '', '', '', true );
                        launchQuiz();
                        $('body')
                            .addClass('bg-lace')
                            .find('.-quiz')
                            .fadeIn(300);
                    }
                });
                $( '.btn-quiz' ).on('click', function ( e ) {
                    $(this).addClass('active');
                    var $carousel = $(this).closest('.carousel');
                    var $slide = $(this).attr('data-slide');
                    var $answer = $(this).children('span').text();
                    var $quizLength = Object.keys($quiz).length;
                    var $correct = $quiz[$slide]['correct'];
                    var $resultSlide = $('.carousel.quiz .carousel-item:last-of-type');
                    var $resultTypes = ['PECCATO','UN BUON RISULTATO','OTTIMO RISULTATO','RISULTATO PERFETTO']
                    window.$answers[$slide] = $answer;
                    $carousel.carousel('next');
            
                    var result = `<div class="col-sm d-flex align-items-start flex-column">
                                    <h5 class="-k font-weight-bold mx-auto">
                                        `+(parseInt($slide)+1)+`-`+$answer+`
                                    </h5>
                                    <p class="mt-auto">
                                        `+$quiz[$slide]['question']+`
                                    </p>
                                    <h5 class="-k font-weight-bold mt-auto mx-auto">
                                        `+$quiz[$slide]['answers'][$correct]+`
                                    </h5>
                                    <img class="d-block mx-auto mt-3" src="/images/icons/colorized/` + ( $correct == $answer ? 'correct.svg' : 'wrong.svg' ) + `" alt="Forma">
                                </div>`
                    
                    if($correct == $answer)
                        $correctAnswers++;
            
                    $resultSlide.find('.row').append( result );
            
                    if($slide == ($quizLength - 1)) {
                        $resultSlide.find('h3')
                            .html($resultTypes[$correctAnswers]+' <span class="d-inline-block align-middle">'+$correctAnswers+'/'+$quizLength+'</span>');
                        $carousel
                            .find('.carousel-indicators')
                            .fadeOut(200);
                    }
                })
            });
        });

        // Add class on nav dropdown show
        $( '.nav-submenu' ).on('show.bs.collapse', function () {
            $shown = $( '.submenu-items.show' );
            if( $shown.length == 0 )
                $( 'nav' ).addClass( 'show');
        });

        $( '.nav-submenu' ).on('hidden.bs.collapse', function () {
            $shown = $( '.submenu-items.show' );
            $collapsing = $( '.submenu-items.collapsing' );
            if( $shown.length == 0 && $collapsing.length == 0 )
                $( 'nav' ).removeClass( 'show');
        });

        // Hide other nav
        $( '.site-nav-toggler' ).on('click', function () {
            if ( !$( '.user-nav-toggler' ).hasClass( 'collapsed' ) )
                $( '.user-nav-toggler' ).trigger( 'click' );
        });

        $( '.user-nav-toggler' ).on('click', function () {
            if ( !$( '.site-nav-toggler' ).hasClass( 'collapsed' ) )
                $( '.site-nav-toggler' ).trigger( 'click' );
        });
        
        // Hide Navbar on scroll down
        var didScroll;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $( 'nav' ).outerHeight();

        $(window).scroll(function(){
            didScroll = true;
            $( 'nav' )[$(window).scrollTop() > 0 ? 'addClass' : 'removeClass']('on-scroll');
        });

        setInterval(function() {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            var st = $(this).scrollTop();
            
            // Make sure they scroll more than delta
            if(Math.abs(lastScrollTop - st) <= delta)
                return;
            
            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.

            if (st > lastScrollTop && st > navbarHeight){
                // Scroll Down
                $( 'nav, nav .dropdown.position-static, nav .dropdown-menu' )
                    .removeClass( 'show' );
                $( '.submenu-items' )
                    .collapse('hide');
                $( 'nav' )
                    .css( 'top', -navbarHeight )
                if ( !$( '.site-nav-toggler' ).hasClass( 'collapsed' ) )
                    $( '.site-nav-toggler' ).trigger( 'click' )
                if ( !$( '.user-nav-toggler' ).hasClass( 'collapsed' ) )
                    $( '.user-nav-toggler' ).trigger( 'click' )
            } else {
                // Scroll Up
                if(st + $(window).height() < $(document).height()) {
                    $( 'nav' )
                        .css( 'top', '0' )
                }
            }
            
            lastScrollTop = st;
        }

        // show tab by menù anchor from same page
        $( 'nav .nav-link' ).on('click', function (e) {
            var href = $(this).attr( 'href' );
            var hash = href.includes( '#' );
            var currentURL = window.location.href.split("#")[0];
            var newURL = href.split("#")[0];
            if( hash && currentURL == newURL ) {
                hash = '#' + href.split('#').pop();
                if( $( 'ul.nav-tabs' ).length > 0 )
                    hash && $( 'ul.nav-tabs a[href="' + hash + '"]' ).tab( 'show' );
                if( $( hash ).find( 'a[data-toggle="collapse"]' ).length > 0 )
                    $( hash ).find( '.collapse' ).collapse('show');
                /*
                $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                    $( 'html,body' ).animate({scrollTop: $( hash ).offset().top}, '500');
                });
                */

                setTimeout(
                    function() {
                        $( 'html,body' ).animate({scrollTop: $( hash ).offset().top},'500');
                    },
                300);

                window.location.href = href;
                e.preventDefault();
            }
        });

        //youtube recipes play video
        if( $( 'body' ).find( '#player' ).length > 0 ) {
            
            // 1. This code loads the IFrame Player API code asynchronously.
            var scripts = document.getElementsByTagName('script');
            var scriptsURLs = [];
            
            for(var i = 0; i < scripts.length; i++) {
                scriptsURLs.push(scripts[i].getAttribute('src'));
            }
        
            if(!scriptsURLs.includes('https://www.youtube.com/iframe_api')) {
                var tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }

            var videoID = $( '#player' ).attr( 'data-video' );
            var slider = $('.carousel');

            // 2. This function creates an <iframe> (and YouTube player)
            //    after the API code downloads.
            var player;
            window.onYouTubeIframeAPIReady = function() {
            player = new YT.Player('player', {
                videoId: videoID,
                events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
                }
            });
            }

            // 3. The API will call this function when the video player is ready.
            function onPlayerReady(event) {
            // event.target.playVideo();
            }

            // 4. The API calls this function when the player's state changes.
            //    The function indicates that when playing a video (state=1),
            //    the player should play for six seconds and then stop.
            function onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.PLAYING) {
                slider.carousel('pause');
                slider.find('>a').fadeOut(300);
            }
            if (event.data == YT.PlayerState.PAUSED || event.data == YT.PlayerState.ENDED) {
                setTimeout(stopVideo, 15000);
            }
            }

            function stopVideo() {
            slider.carousel('cycle');
            slider.find('>a').fadeIn(300);
            player.stopVideo();
            }

            slider.on('slide.bs.carousel', function () {
            stopVideo();
            })
        }

        // flip card temporeggio
        $( '.flip .card-button' ).on('click', function ( e ) {
            var $target = $(e.target);
            var $card = $( this ).closest( '.card' );
            if( $target.is('u') ) {
                $card.toggleClass('active');
                //.find('.card-inner>div').toggleClass('z-2');
                e.preventDefault();
            }
        });

        $( '.-start-game' ).on('click', function ( e ) {
            $('.-intro').fadeOut(300, function() {
                $('body')
                    .addClass('bg-lace')
                    .find('.game-container')
                    .fadeIn(300);
            });
        });

        $( '.-end-game' ).on('click', function ( e ) {
            $('.-intro, .game-container').fadeToggle(300, function() {
                $('body')
                    .removeClass('bg-lace')
            });
        });

        // registration form, hide/show parent email input
        $( 'select[name="date_of_birth[year]"]' ).change(function( e ) {
            var yearSelected = $( this ).find( 'option:selected' ).val();
            var date = new Date();
            var year = date.getFullYear();
            //console.log(parseInt(yearSelected)+18, year)
            $( 'input[name="parent_email"]' ).closest( '.form-group' ).toggle(parseInt(yearSelected)+18 > year);
        });

        // show/hide intro collapse on nutritionist page
        $( '.nutritionist-page a[data-toggle="collapse"]' ).on('click', function () {
            $( this ).closest( '.d-lg-flex' ).find( 'h5' ).toggle( 'opacity' );
        });

        //Initialize Custom Inputs
        if ( $('body').find('.custom-control-input').length > 0 )
            bsCustomFileInput.init();

        // Switch bootstrap custom control input (checkboxes) on change: assign value ( 1 check | 0 uncheck )
        $( '.main-form input[type="checkbox"].custom-control-input' ).each(function () {
            $('<input />')
            .attr( { 'name': $( this ).attr( 'name' ), 'type': 'hidden' } )
            .val( '0' )
            .insertBefore( $( this ) );
        });

        $( '.-select input[name="subject"]' ).change(function( e ) {
            $checkedID = $( this ).attr( 'id' );
            $prodsIDs = $checkedID == 'form-information' || $checkedID == 'form-conform';
            $( '.-select input[name="prods"]' )
                .prop( 'checked', $prodsIDs );
        });

        $( '.-select input[name="prods"]' ).change(function( e ) {
            $( '.-select input[name="subject"]' )
                .prop( 'checked', false );
        });
        
        // customer service step form
        $( '.-next' ).click(function (e) {
            
            $subject = $( 'input[name="subject"]:checked' ).val();
            $infoPack = $( '.-pack' );

            //conform inputs
            $pack = $( 'input[name="pack"]' );
            $barcode = $( 'input[name="barcode"]' );
            $lot = $( 'input[name="lot"]' );
            $expiration = $( '.-pack select' );
            $modal = $(".generic-modal");

            if( $subject ) {
                $infoPack.find( 'input, select' ).prop( 'disabled', true );

                // set storage item called subject
                sessionStorage.setItem( 'subject', $subject );
            
                $( '.-select' ).fadeOut( 500, function() {
                    $( 'h4, .-form' ).fadeIn(500);
                    $( 'html,body' ).animate( {scrollTop: ( $( 'form' ).offset().top ) - 100 }, 300 );
                    //information
                    //conform
                    if( $subject == 'Prodotti / segnalazione di non conformità' ) {
                        $pack.closest( '.form-group' ).fadeIn(300);
                        $pack.change(function( e ) {
                            $checkedPack = $( this ).val();
                            $checkedPack == '1' ? $infoPack.fadeIn(300) : $infoPack.fadeOut(300);
                            $infoPack.find( 'input, select' ).prop( 'disabled', $checkedPack == '0' );
                        });
                    }
                });
            } else {
                $title = `ATTENZIONE!`;
                $body = `<p>Devi effettuare una scelta per poter proseguire, grazie.</p>`;
                if( $( 'input[name="prods"]' ).is(':checked') )
                    $body = `<p>Scegli il tipo di richiesta inerente ai prodotti, grazie.</p>`;
                $modal.find( '.modal-title' ).html( $title );
                $modal.find( '.modal-body' ).html( $body );
                $modal.find( '.btn-fill' ).html( 'Chiudi' );
                $modal.modal();
            }
            
        });

        /*
        $( '.-back' ).click(function (e) {
            e.preventDefault();
            $( 'form' )[0].reset();
            $( 'input[name="pack"]' )
            .closest( '.form-group' )
            .fadeOut(300);
            sessionStorage.removeItem( 'subject' );
            $( 'h4, .-form' ).fadeOut( 500, function() {
                $( 'h4, .-select' ).fadeIn(500);
                $( 'html,body' ).animate( {scrollTop: ( $( '.-select .card' ).offset().top ) - 100 }, 300 );
            });
        });
        */

        $form = $( '.-form' );
        $sessionSubject = sessionStorage.getItem( 'subject' );
        if( $sessionSubject != null && $sessionSubject == 'Prodotti / segnalazione di non conformità' && $form.css( 'display' ) != 'none' ) {
            //conform inputs
            $pack = $( 'input[name="pack"]' );
            $infoPack = $( '.-pack' );
            $pack.closest( '.form-group' ).fadeIn(300);
            $pack.change(function( e ) {
                $checkedPack = $( this ).val();
                $checkedPack == '1' ? $infoPack.fadeIn(300) : $infoPack.fadeOut(300);
                $infoPack.find( 'input, select' ).val('', $checkedPack == '0').prop( 'disabled', $checkedPack == '0' );
            });
        }

        if( $sessionSubject != null && $form.css( 'display' ) == 'none' )
            sessionStorage.removeItem( 'subject' );

        $( '.-form select[name="product"]' ).change(function( e ) {
            $selectedValue = $( this ).val();
            $other = $( '.-form input[name="other_product"]' );
            $selectedValue == 'ALTRO' ? $other.val( '' ).fadeIn(300) : $other.val( '' ).fadeOut(300);
        });

        $( '.-form select[name="brand"]' ).change(function( e ) {
            $selectedValue = $( this ).val();
            $other = $( '.-form input[name="other_brand"]' );
            $selectedValue == 'ALTRO' ? $other.val( '' ).fadeIn(300) : $other.val( '' ).fadeOut(300);
        });

        $('.share-recipe').click(function(e) {
            $.ajaxSetup({ cache: true });
            $link = $( this ).attr( 'href' );
            FB.ui({
                    method: 'share',
                    href: $link
                },
                function(response) {
                    if ( response && !response.error_code ) {
                        $(".game-modal")
                            .find('.modal-title').html('Condivisione su Facebook')
                            .find('.modal-body').html('Complimenti, hai condiviso il gioco degli stickers Parmareggio con i tuoi amici.')
                            .find('.btn-fill').html('Chiudi')
                            .modal();
                    } else 
                        $(".game-modal")
                            .find('.modal-title').html('Condivisione su Facebook')
                            .find('.modal-body').html('Siamo spiacenti, la condivisione è fallita.')
                            .find('.btn-fill').html('Chiudi')
                            .modal();
                })

            e.preventDefault();

        });

        $('.print-recipe').click(function(e) {
            window.print();
            e.preventDefault();
        });
        
        // sitemap no redirect link
        $( '.-nrl' ).click(function (e) {
            e.preventDefault();
        });

    }

};